import React from 'react';
import Layout from '../../Components/Layout';

function Settings() {
  return (
    <Layout>
      <h2>Settings</h2>
      <p>Settings page content goes here.</p>
    </Layout>
  );
}

export default Settings;
